export default __webpack_public_path__ + "static/scores@2x-ea3914398ce904439129f361c3f0a6a3.webp";